import { useQuery } from '@tanstack/react-query';

import { MetadataClient, ReportType } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const metadataClient = new MetadataClient(apiBaseUrl);

function useGetFormMetadataByReportType(reportType?: ReportType) {
  return useQuery({
    queryKey: [queryKeys.Metadata.Metadata, { reportType }],
    staleTime: 5 * 60 * 1000,
    queryFn: () => reportType && metadataClient.getFormMetadataByReportType(reportType),
  });
}

export default useGetFormMetadataByReportType;
